import { Button, Row, Col, Typography, Input, Form, Card } from "antd";
import { useState } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import "./login.css"
const { Title, Text } = Typography;

export const LoginWrapper = ({ children }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = () => {
    if (username === "admin" && password === "buzzreports@2025") {
      setIsAuthenticated(true);
      setError("");
    } else {
      setError("❌ Invalid username or password.");
    }
  };

  if (isAuthenticated) return children;

  return (
    <Row
      style={{
        height: "100vh",
        background: "linear-gradient(135deg, #eef2f9, #dbe7ff)",
        justifyContent: "center",
        alignItems: "center",
        padding: "1rem",
      }}
    >
      <Card
        style={{
          width: "auto",
          padding: "40px 30px",
          borderRadius: "20px",
          boxShadow: "0 12px 48px rgba(0, 0, 0, 0.1)",
          background: "#fff",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>🔐</div>
          <Title level={3} style={{ fontWeight: 700, margin: 0 }}>
            Welcome to <span style={{ color: "#6b63ff" }}>BuzzReports</span>
          </Title>
          <Text type="secondary">Login to continue</Text>
        </div>

        <Form layout="vertical" onFinish={handleLogin}>
          <Form.Item label="Username">
            <Input
              size="large"
              placeholder="Enter username"
              prefix={<UserOutlined />}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{ borderRadius: 8 }}
            />
          </Form.Item>

          <Form.Item label="Password">
            <Input.Password
              size="large"
              placeholder="Enter password"
              prefix={<LockOutlined />}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ borderRadius: 8 }}
            />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            size="large"
            block
            style={{
              marginTop: 16,
              borderRadius: 8,
              background: "linear-gradient(to right, #6b63ff, #988aff)",
              fontWeight: 600,
              boxShadow: "0 4px 12px rgba(107, 99, 255, 0.3)",
            }}
          >
            Login
          </Button>

          {error && (
            <Text type="danger" style={{ display: "block", marginTop: 16, textAlign: "center" }}>
              {error}
            </Text>
          )}
        </Form>
      </Card>
    </Row>
  );
};
